var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group,index){return _c('v-row',{key:index},_vm._l((group),function(chart){return _c('v-col',{key:chart.id,attrs:{"cols":chart.width}},[_c('Plot',{attrs:{"data":chart.data,"layout":chart.layout}})],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }